// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import AppointmentActions from './data'

export default function AppointmentActionsFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/AppointmentActions">
      <AppointmentActions {...props}>
        {children}
      </AppointmentActions>
    </Flow>
  )
}
